import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';

import { switchMap, of, catchError } from 'rxjs';

import { isUUID } from 'class-validator';

import { OrganizationsService } from '../../modules/organizations/organizations.service';
import { PaginationArgs } from '../../shared/components/pagination/models/pagination-args.model';
import { PageTitleModel } from '../../shared/models/routes/page-title.model';

function getPathSegments(route: ActivatedRouteSnapshot): string[] {
	let pathSegments: string[] = [];

	while (route) {
		pathSegments = [
			...route.url.map((segment) => segment.path),
			...pathSegments,
		];
		route = route.parent as ActivatedRouteSnapshot;
	}

	return pathSegments;
}

export const resolvePageTitle: ResolveFn<PageTitleModel> = (route) => {
	const organizationsService = inject(OrganizationsService); // Injeta o serviço necessário
	const routePaths = getPathSegments(route);

	if (routePaths[0] === 'organizacoes' && routePaths.length > 1) {
		const organizationIdPosition = 1;
		const organizationId = routePaths[organizationIdPosition];

		if (isUUID(organizationId)) {
			return organizationsService
				.findMany(
					new PaginationArgs({
						page: 1,
						select: {
							name_secondary: true,
						},
						where: {
							id: organizationId,
						},
					}),
				)
				.pipe(
					switchMap((data) => {
						if (data.result.length) {
							return of({ label: data.result[0].name_secondary });
						} else {
							return of({ label: 'Organização não encontrada' });
						}
					}),
					catchError(() => of({ label: 'Erro ao buscar organização' })),
				);
		}
	}

	return of({ label: 'Titulo não tratado' });
};
